import { CostAssignmentType } from '../enums';

type InvoiceLabelForCostAssignmentType = { [key in CostAssignmentType]: string };

export const INVOICE_COST_ASSIGNMENT_LABEL: InvoiceLabelForCostAssignmentType = {
  [CostAssignmentType.BENEFIT_AMOUNT]: 'Leistungsbetrag der Kasse nach § 43 SGB XI',
  [CostAssignmentType.SUPPLEMENT_43C]: 'Leistungszuschlag nach § 43c SGB XI',
  [CostAssignmentType.SURCHARGE_43B]: 'Übernahme Vergütungszuschlag nach § 43b SGB XI',
  [CostAssignmentType.SURCHARGE_84_9]: 'Übernahme § 132g Abs. 3 SGB V',
  [CostAssignmentType.NURSING_HOME_ALLOWANCE]: 'Pflegewohngeld',
  [CostAssignmentType.MONTHLY_INCOMING_SUPPORT]: 'Taschengeld',
  [CostAssignmentType.SOCIAL_ASSISTANCE]: 'Sozialhilfe',
  [CostAssignmentType.MONTHLY_INCOMING_FUND]: 'Privatzahler',
  [CostAssignmentType.WITHOUT_MONTHLY_INCOMING_FUND]: 'Privatzahler',
  [CostAssignmentType.INVESTMENT_COST_SUPPLEMENT]: 'Investitionskostenzuschlag',
};

export const INVOICE_COST_ASSIGNMENT_OPEN_PAYMENTLABEL: InvoiceLabelForCostAssignmentType = {
  [CostAssignmentType.BENEFIT_AMOUNT]: 'LBetrag §43',
  [CostAssignmentType.SUPPLEMENT_43C]: 'LZ §43c',
  [CostAssignmentType.SURCHARGE_43B]: 'VgZ §43b',
  [CostAssignmentType.SURCHARGE_84_9]: '§ 132g Abs. 3 SGB V',
  [CostAssignmentType.NURSING_HOME_ALLOWANCE]: 'PWohngeld',
  [CostAssignmentType.MONTHLY_INCOMING_SUPPORT]: 'Taschengeld',
  [CostAssignmentType.SOCIAL_ASSISTANCE]: 'Sozialhilfe',
  [CostAssignmentType.MONTHLY_INCOMING_FUND]: 'sonst.m.Eing',
  [CostAssignmentType.WITHOUT_MONTHLY_INCOMING_FUND]: 'Privatzahler',
  [CostAssignmentType.INVESTMENT_COST_SUPPLEMENT]: 'Investitionskostenzuschlag',
};
